import config from '@config';

export function getFileFromBucket(path: string) {
  return `https://${config.marekImagesBucketDomain}/${path}`;
}
